// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"72bb16a2","115":"e6459a31","173":"7b5577fa","380":"6f17697d","729":"1d6ee237","772":"94a655c0","843":"9a77955c","858":"f2ef1bb7","886":"f3918e7f"}[chunkId] + ".chunk.js";
};